export const createEnumMap = <K extends string | number | symbol, T, F>(
  obj: Partial<Record<K, T>>,
  enumObj: Record<string, K>,
  fallback: F
) => {
  return Object.values(enumObj).reduce((acc, value) => {
    const typedValue = value as K;
    acc[typedValue] = typedValue in obj ? (obj[typedValue] as T) : (fallback as F);
    return acc;
  }, {} as Record<K, T | F>);
};
